import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext, useSettingsContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'renters/installed';
const wizardName = 'Apply action';
const wizardAction = 'applyAction';
const wizardObject = 'Installed';


const ApplyAction = (params) => {
    const { t } = useTranslation();
    const { existingModules } = useContext(AppContext);

    // DATA PROVIDER
    const {
        loadAll,
        errorMessage,
        errors,
        saving,
        doAction,
    } = useDataProvider(dataProviderName, params.multipart);

    const moduleConfig = existingModules?.[dataProviderName] ?? {};
    const modelName = moduleConfig?.modelName;
    const availableActions = Array.isArray(moduleConfig?.availableActions)
        ? [...new Set(moduleConfig.availableActions
            .filter(action => typeof action === 'string' && action.trim() !== '')
            .map(action => action.trim()))]
        : [];


    const { settings, editFilter } = useSettingsContext(dataProviderName);


    const filters = {
        sort: settings.sortModel,
        itemsFilters: settings.filterModel,
        perPage: 100000,
        columns: Object.keys(settings.visibilityModel).filter(key => settings.visibilityModel[key] === true),
    }

    const detailConfig = {
        "tabs": [
            {
                "name": "actions",
                "fieldsets": [
                    {
                        "name": "actions",
                        "fields": {
                            "action": {
                                "type": "select",
                                "options": availableActions.map(itm => {
                                    return {
                                        label: itm,
                                        value: itm
                                    }
                                }),
                                "required": true,
                                "className": "col-4"
                            },
                            "apply_to": {
                                "type": "select",
                                "options": [
                                    {
                                        label: "selected_items",
                                        value: "selected_items",
                                    },
                                    {
                                        label: "filtered_items",
                                        value: "filtered_items",
                                    }
                                ],
                                "required": true,
                                "className": "col-8"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const handleSave = (data) => {
        doAction({
            action: wizardAction,
            model: dataProviderName,
            model_ids: params.items,
            data: { ...data, model_ids: params.items, filters: filters }
        }).then((data) => {
            //editFilter('processStatus', 'queued', 'equals');
            loadAll();
            if (params.onActionDone) {
                params.onActionDone();
            }
            params.handleClose(params.uid, data.item.data)
        }).catch(() => console.error('catch handleSave'));
    }


    return <>
        {/* {params.items.map((item)=>   <>{JSON.stringify(getOne(item))}</>)} */}
        <DetailComponent
            values={{apply_to:"filtered_items"}}
            modelName={modelName}
            detailConfig={detailConfig}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={true}
            // canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t(
                        'Apply action to {{wizardObject}} ({{total}} selected)',
                        {
                            wizardObject: t(wizardObject),
                            total: params.items.length,
                        }
                    )}
                />
            }
            {...params}
        />
    </>
}

export default ApplyAction;


